export default "__VITE_ASSET__DedPNATU__"